/* Copyright Information: Created by BuyGroup */
import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import "../Quotes/Quotes.css";

const AssignProductsModal = ({
  isOpen,
  toggle,
  products,
  onSubmit,
  isSubmitting,
}) => {
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const filteredProducts = React.useMemo(() => {
    if (!products || !products.length) return [];
    const q = (searchQuery || "").trim().toLowerCase();
    if (!q) return products;
    return products.filter((p) => {
      const name = (p.name).toString().toLowerCase();
      return name.includes(q);
    });
  }, [products, searchQuery]);

  const handleProductCheckboxChange = (productId) => {
    setSelectedProducts((prev) => {
      if (prev.includes(productId)) {
        return prev.filter((id) => id !== productId);
      } else {
        return [...prev, productId];
      }
    });
  };

  const handleSubmit = () => {
    if (selectedProducts.length === 0) return;
    console.log("selectedProducts", selectedProducts);
    onSubmit(selectedProducts);
  };
  // initialize selectedProducts from products' assigned flags when modal opens or products change
  useEffect(() => {
    if (isOpen && products && products.length) {
      const initial = products
        .filter((p) => p.is_assigned)
        .map((p) => p.product_id);
      setSelectedProducts(initial);
    }
  }, [isOpen, products]);

  const handleClose = () => {
    setSelectedProducts([]);
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose} size="lg">
      <ModalHeader toggle={handleClose}>Assign Products</ModalHeader>
      <ModalBody>
        {products && products.length > 0 ? (
          <div className="supplier-list-container">
            <div className="mb-2">
              <Input
                type="search"
                placeholder="Search products"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
            {filteredProducts && filteredProducts.length > 0 ? (
              filteredProducts.map((product) => {
                const prodId = product.product_id || product.id || product.productId;
                return (
                  <div key={prodId} className="supplier-item-wrapper">
                    <FormGroup check className="supplier-item">
                      <Label check>
                        <Input
                          type="checkbox"
                          checked={selectedProducts.includes(prodId)}
                          onChange={() => handleProductCheckboxChange(prodId)}
                        />
                        <div className="supplier-info">
                          <div className="supplier-name">
                            {product.product_name || product.name}
                          </div>
                        </div>
                      </Label>
                    </FormGroup>
                  </div>
                );
              })
            ) : (
              <div className="text-muted">No products match your search</div>
            )}
          </div>
        ) : (
          <div className="text-muted">No products available</div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={isSubmitting || selectedProducts.length === 0}
        >
          {isSubmitting ? "Please Wait..." : "Submit"}
        </Button>
        <Button color="light" onClick={handleClose} disabled={isSubmitting}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AssignProductsModal;
